var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCategories = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.001,
    viewBox: "0 0 18 18.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_categories",
    d: "M201.193,665.98l2.7-2.7a1.047,1.047,0,0,1,1.482,0l2.7,2.7a1.049,1.049,0,0,1,0,1.482l-2.7,2.7a1.047,1.047,0,0,1-1.482,0l-2.7-2.7A1.047,1.047,0,0,1,201.193,665.98Zm5.25,5.25,2.7-2.7a1.047,1.047,0,0,1,1.482,0l2.7,2.7a1.049,1.049,0,0,1,0,1.482l-2.7,2.7a1.047,1.047,0,0,1-1.482,0l-2.7-2.7A1.047,1.047,0,0,1,206.443,671.229Zm-10.5,0,2.7-2.7a1.047,1.047,0,0,1,1.482,0l2.7,2.7a1.049,1.049,0,0,1,0,1.482l-2.7,2.7a1.047,1.047,0,0,1-1.482,0l-2.7-2.7A1.047,1.047,0,0,1,195.944,671.229Zm5.249,5.249,2.7-2.7a1.047,1.047,0,0,1,1.482,0l2.7,2.7a1.049,1.049,0,0,1,0,1.482l-2.7,2.7a1.047,1.047,0,0,1-1.482,0l-2.7-2.7A1.047,1.047,0,0,1,201.193,676.478Z",
    transform: "translate(-195.637 -662.97)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCategories);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_categories.910b4d4b1bceb1a4dd270caaf7ecf484.svg";